// extracted by mini-css-extract-plugin
module.exports = {"payslipOuter":"_1AzxS","close":"_2r3QU","imageSource":"_37PEt"};